import React, { type FC, Fragment, type SyntheticEvent } from "react";
import type { CommonFinanceInfoType } from "../../../../../../../common-deprecated/types/CommonTypes";
import { useModelFilterDispatch } from "../../../../redux/store";
import { showModal } from "../../../../../../../common-deprecated/redux/actions/ModalActions";
import { MODAL_FINANCE_DISCLAIMER } from "../../../../../../../common-deprecated/utils/modalConstants";
import { CommonMonthlyPriceLabelKey } from "../../../../../../../common-deprecated/priceUtils";
import * as Styles from "./style/ModelResultPriceStyles";
import SrOnly from "../../../../../../../common-deprecated/styles/v2/lexus/utilities/ScreenreaderOnly";
import { ModelFilterLabel } from "../../../../utils/labels";
import Icon from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";

type PriceLabelsProps = {
    labels: Array<{ key: string; value: string }>;
    showTooltip: boolean;
    financeInfo: CommonFinanceInfoType | null;
    hideFinanceTooltip: boolean;
};

const PriceLabels: FC<PriceLabelsProps> = ({ labels, showTooltip, financeInfo, hideFinanceTooltip }) => {
    const dispatch = useModelFilterDispatch();

    const getDisclaimerFn =
        (info: CommonFinanceInfoType) =>
        (event: SyntheticEvent): void => {
            event.preventDefault();
            event.stopPropagation();
            if (!info.disclaimer) return;
            dispatch(
                showModal({
                    type: MODAL_FINANCE_DISCLAIMER,
                    disclaimer: info.disclaimer,
                    productName: info.productName || "",
                }),
            );
        };

    return (
        <>
            {labels.map(({ key, value }) => (
                <Fragment key={key}>
                    {key === CommonMonthlyPriceLabelKey.Price ? (
                        <Styles.Monthly onClick={financeInfo?.disclaimer ? getDisclaimerFn(financeInfo) : undefined}>
                            <span dangerouslySetInnerHTML={{ __html: value }} />

                            {showTooltip && !hideFinanceTooltip && !!financeInfo?.disclaimer && (
                                <Styles.MonthlyPriceDisclaimer>
                                    &nbsp;
                                    <SrOnly>
                                        <ModelFilterLabel label="modelfilterA11yButtonReadDisclaimer" />
                                    </SrOnly>
                                    <Styles.DisclaimerIcon>
                                        <Icon variant="info" aria-hidden="true" />
                                    </Styles.DisclaimerIcon>
                                </Styles.MonthlyPriceDisclaimer>
                            )}
                        </Styles.Monthly>
                    ) : (
                        <Styles.LegalText dangerouslySetInnerHTML={{ __html: value }} />
                    )}
                </Fragment>
            ))}
        </>
    );
};

export default PriceLabels;
